import lrsAdapter from '../../../../../helpers/lrs_adapter'
import getAxiosInstance from '../../../../../helpers/get_axios_instance'

export class TablaConsultaCodigoCupoParaActorService {
  static async getDataConsultaCodigoCupoParaActor () {
    const axios = getAxiosInstance()
    return axios.get('/consulta_codigo_cupo_para_actor').then(lrsAdapter, lrsAdapter)
      .then(result => result ? result.data : [])
  }
}
